const Scroll = ($, context) => {
  const $invertPoint = $(".invertPoint", context);

  // Don't run if there is no invertpoint element on the page
  if($invertPoint.length === 0) {
    return {init:()=>{}};
  }

  var self = {
    init: () => {
      var scrollTimer, lastScrollFireTime = 0;

      $(window).on('scroll', function() {
          const bodyEl = $('body');
          const minScrollTime = 50;
          const now = new Date().getTime();
          const viewportTop = $(window).scrollTop();
          const viewportBottom = viewportTop + $(window).height();

          // Used to trigger some animations faster if we scroll past a certain amount
          function bodyHasScrolledCheck() {
            const scrollAmountTrigger = 50;

            if(viewportTop > scrollAmountTrigger) {
              bodyEl.addClass('scrolled');
            }
          }

          // Used on pages to determine where the page should 'invert', or turn to
          // a dark mode style with white text and graphics over a dark purple body background.
          function inversionScrollCheck() {
            const bodyIsInverted = $('body').hasClass('inverted');
            const elementTop = $invertPoint.offset().top;

            // if we go from home to another page it's still looking for it, 
            // we can determine it's not on the page if the top is 0.
            // (an invert point would never be at the top so this should be safe)
            if (elementTop === 0) {
              return;
            }
          
            // const invertPointIsInView = elementBottom > viewportTop && elementTop < viewportBottom;
            const invertPointIsInViewOrPast = elementTop < viewportBottom;

            if(invertPointIsInViewOrPast) {
              if(!bodyIsInverted) {
                bodyEl.addClass('inverted');
              }
            } else {
              bodyEl.removeClass('inverted');
            }
          };

          function processScroll() {
            bodyHasScrolledCheck();
            inversionScrollCheck();
          }

          if (!scrollTimer) {
              if (now - lastScrollFireTime > (3 * minScrollTime)) {
                  processScroll();   // fire immediately on first scroll
                  lastScrollFireTime = now;
              }
              scrollTimer = setTimeout(function() {
                  scrollTimer = null;
                  lastScrollFireTime = new Date().getTime();
                  processScroll();
              }, minScrollTime);
          }
      });
    }
  }

  return self;
}

export default Scroll